import { render, staticRenderFns } from "./AllFinish.vue?vue&type=template&id=ddfc9a80&"
import script from "./AllFinish.vue?vue&type=script&lang=js&"
export * from "./AllFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports